import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import RedwingLogo from "../../../resources/images/logo2.svg";
import { formatReleaseMeta, hasReadingOrder } from "../helpers/releases";

/**
 * Same badge as the mobile app's Redwing variant: dark pill, Redwing logo,
 * red outline.
 */
const ReadingOrderBadge = () => (
  <Flex
    display="inline-flex"
    alignItems="center"
    mt="2"
    px="2"
    py="1"
    bg="rgba(0, 0, 0, 0.75)"
    borderWidth="1px"
    borderColor="#ED1D24"
    borderRadius="full"
  >
    <Image src={RedwingLogo} alt="" boxSize="14px" mr="1" />
    <Text fontSize="11px" lineHeight="15px">
      Reading order available
    </Text>
  </Flex>
);

/**
 * A movie / show season row on the Cinematic Universes page: poster,
 * title, "Film · 18 Dec 2026" and a badge when a reading order is linked.
 * Mirrors the mobile ReleaseCard component.
 */
const ReleaseCard = ({ release, onClick }) => {
  if (!release) {
    return null;
  }

  const meta = formatReleaseMeta(release);
  const linked = hasReadingOrder(release);

  return (
    <Flex
      as={Link}
      to={`/browse/releases/${release.id}`}
      state={{ release }}
      onClick={onClick}
      aria-label={`${release.title}. ${meta}${
        linked ? ". Reading order available" : ""
      }`}
      bg="gray.700"
      borderRadius="lg"
      overflow="hidden"
      transition="opacity 0.15s"
      _hover={{ opacity: 0.85 }}
      _focusVisible={{ boxShadow: "outline", outline: "none" }}
    >
      <Box w="64px" h="96px" flexShrink={0} bg="gray.800">
        {!!release.posterUrl && (
          <Image
            src={release.posterUrl}
            alt=""
            w="100%"
            h="100%"
            objectFit="cover"
            draggable={false}
          />
        )}
      </Box>
      <Box px="4" py="3" minW="0" flex="1" alignSelf="center">
        <Text fontWeight="bold" noOfLines={2}>
          {release.title}
        </Text>
        <Text fontSize="sm" color="gray.400" noOfLines={1}>
          {meta}
        </Text>
        {linked && <ReadingOrderBadge />}
      </Box>
    </Flex>
  );
};

export default ReleaseCard;
